import { colorMap, getCookie } from '@/utils';

// 获取当前主题
const getTheme = () => (getCookie('cusSkin') === '1' ? 'dark' : 'light');

// k线图颜色
const getTradingViewColors = () => ({
  dark: {
    toolbarBg: colorMap['a-6-bg'], // 工具栏底色
    textColor: colorMap['b-3-cl'], // 图标区域xy轴 文字颜色
    lineColor: colorMap['a-3-bd'], // 图标区域xy轴颜色
    background: colorMap['a-6-bg'], // 图标区域 背景色
    vertGridProperties: colorMap['a-7-bg'], // 图标区域 表格纵轴颜色
    horzGridProperties: colorMap['a-7-bg'], // 图标区域 表格橫轴颜色
  },
  light: { // 参照binance配色
    toolbarBg: colorMap['u-16-cl'],
    textColor: colorMap['b-3-cl'],
    lineColor: colorMap['u-21-bd'],
    background: colorMap['u-16-cl'],
    vertGridProperties: colorMap['u-20-cl'],
    horzGridProperties: colorMap['u-20-cl'],
  },
}[getTheme()]);

export { getTheme, getTradingViewColors };
